import React from "react";
import { useTable } from "../../Components/useTable";

const AllBannersList = () => {
  const type = "All Banners";
  const limitPerpage = 100;
  const pageRowslinit = [20, 50, 100];
  const headCells = [
    { id: "picture", numeric: false, label: "Image" },
    { id: "screen", numeric: false, label: "Screen" },
    { id: "link", numeric: false, label: "URL" },
    { id: "country", numeric: false, label: "Country" },
    { id: "isExpired", numeric: false, label: "Expired" },
    { id: "isActive", numeric: false, label: "Status" },
    { id: "startTime", numeric: false, label: "Start Time" },
    { id: "endTime", numeric: false, label: "End Time" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default AllBannersList;
